export const ORGANIZATION_FILTER_KEYS = ["type"];
//# sourceMappingURL=types.js.map